/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reconcile_IgnoreInputs */

const vi_reconcile_ignore = /** @type {(inputs: Reconcile_IgnoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bỏ qua`)
};

/**

* @param {Reconcile_IgnoreInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const reconcile_ignore = /** @type {((inputs?: Reconcile_IgnoreInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reconcile_IgnoreInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_reconcile_ignore(inputs)
});